import { useInfiniteQuery } from '@tanstack/react-query';
import { rmCopilotHttpClient } from 'api/rm-copilot';
import { GENERAL_API_STALE } from 'config/query-config';
export const RM_COPILOT_QUERY_KEYS = {
    all: [
        'rm-copilot'
    ],
    chatHistoryAll: ()=>[
            ...RM_COPILOT_QUERY_KEYS.all,
            'history'
        ],
    chatHistory: (limit)=>[
            ...RM_COPILOT_QUERY_KEYS.all,
            'history',
            limit
        ]
};
const LIMIT_DEFAULT = 20;
export const useRmAgentChatHistoryInfiniteQuery = (params, options)=>{
    var _params_limit;
    const limit = (_params_limit = params.limit) !== null && _params_limit !== void 0 ? _params_limit : LIMIT_DEFAULT;
    const { ...restOptions } = options || {};
    return useInfiniteQuery({
        queryKey: RM_COPILOT_QUERY_KEYS.chatHistory(limit),
        queryFn: ({ pageParam = 0 })=>{
            const offset = pageParam;
            return rmCopilotHttpClient.getAllConversations({
                limit,
                offset
            });
        },
        getNextPageParam: (lastPage, allPages)=>{
            if (!lastPage || !lastPage.conversations) {
                return undefined;
            }
            if (lastPage.conversations.length === limit) {
                const totalItemsLoaded = allPages.reduce((sum, page)=>{
                    var _page_conversations;
                    return sum + (((_page_conversations = page.conversations) === null || _page_conversations === void 0 ? void 0 : _page_conversations.length) || 0);
                }, 0);
                return totalItemsLoaded;
            }
            return undefined;
        },
        staleTime: GENERAL_API_STALE,
        cacheTime: GENERAL_API_STALE,
        ...restOptions
    });
};
